import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { API } from 'src/app/configs';
import { HttpService } from 'src/app/core/http/http.service';
import { DialogActionComponent } from 'src/app/shared/components/dialog-action/dialog-action.component';
import { GeneralService } from 'src/app/shared/services/general.service';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit, OnDestroy {


    tabActive = 'users';

    usersManagerList = [];

    perfil = [];

    userData:any = {};

    companieSelData:any = {};

    userMax = 5;

    protected companieSelSubscription: Subscription;
    protected transactionDataSubscription: Subscription;
    protected userdataSubscription: Subscription;

    constructor(
        public gs: GeneralService,
        protected httpService: HttpService,
        public dialog: MatDialog) {
        
        this.perfil = this.gs.getGeneralData('perfil');

        this.transactionDataSubscription = this.gs.transactionData.subscribe(result => {
            if(result?.method == 'usersManager' && result?.action == 'new'){
                this.usersManager('list');
            }
        });
    }

    ngOnInit() {
        this.companieSelSubscription = this.gs.companiesSel$.subscribe(result => {
            this.companieSelData = this.gs.getCompanieData(result);
            this.userMax = this.companieSelData?.company_person_limit || 5;
            this.setDefault();
        });
        this.userdataSubscription = this.gs.userdata$.subscribe(result => {
          this.userData = result;
        });
    }

    ngOnDestroy(){
      this.userdataSubscription?.unsubscribe();
    }
    
    setDefault(){
        this.usersManager('list');
    }

    usersManager(action, data = null, ev = null){
        if(!this.companieSelData?.company_person_id)
          return;
    
        if(ev instanceof MouseEvent)
          ev.stopPropagation();
    
    
        switch(action){
          case 'new':
    
            if(this.usersManagerList.length >= this.userMax)
              return this.gs.error(null,'Limite máximo excedido');

            this.gs.navigate(['openModal', 'UsersManagerComponent'],{queryParams:{json:JSON.stringify({id:this.companieSelData?.company_person_id})}});
          break;
          case 'delete':
              const dialogRef = this.dialog.open(DialogActionComponent, 
                  {
                   data: {
                      title:'Realmente deseja excluir o acesso do usuário?',
                      content:'<b>'+data.person_name+'</b>',
                      cancelTitle:'Cancelar',
                      okTitle:'Excluir',
                      okClass:'btn-danger'
                  }});
          
              dialogRef.afterClosed().subscribe(result => {
                if(result)
                  this.usersManager('doDelete', data, ev);
              });
              return;
          break;
          case 'doDelete':
            this.httpService.del<any>(API.person.general.companyuser,{
              "owner_person_id":this.companieSelData?.company_person_id,
              person_id: data?.person_id
            }).then(
                result => {
                    this.usersManager('list');
                    this.gs.message('Usuário removido com sucesso');
            })
            .catch(err => this.gs.error(err));
          break;
          case 'list': 
            this.httpService.post<any>(API.person.general.companyuser, {
              "owner_person_id":this.companieSelData?.company_person_id
            })
            .then(result => {
                this.usersManagerList = result.list.map(item => {
                    if(item?.avatar){
                        let avatar = this.gs.adjustAvatarFiles(item);
                        item.avatarFile =  this.gs.getAvatarFile(avatar);
                    }
                    return item;
                });

            })
            .catch(err => this.gs.error(err));
          break;
          case 'copyLink':
            const el = document.createElement('textarea');
            el.value = 'https://www.centralcorretor.com.br/emailsignup/'+data?.hash;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            this.gs.message('Link copiado');
          break;
        }
      }

}
